import DocumentFusion from "../../components/Common/documentFusion";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Link, useNavigate } from "react-router-dom";
import Config from "config";
import { Nav, NavItem, NavLink } from "reactstrap";
const SauvegardesAttestationDetail = () => {
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  const [loading, setLoading] = useState(true);
  const [sauvegardesAttestationData, setSauvegardesAttestationData] = useState(
    []
  );
  const [activeTab, setActiveTab] = useState("details");
  const token = localStorage.getItem("auth_token_" + api);
  const [signature, setSignature] = useState(false);
  const [wait, setWait] = useState(1000);
  console.log(wait);
  let { id } = useParams();
  const navigate = useNavigate();
  const handleNavigate = () => {
    localStorage.setItem("key", true);
    navigate(-1);
  };
  const handleAction = async (action) => {
    console.log(
      `https://www.fluxod.com/${api}/${action?.controller}/${action?.action}?sauvegardes_attestation_id=${action?.params?.sauvegardes_attestation_id}`
    );
    toast.info("Demande en cours...");
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/${action?.controller}/${action?.action}?sauvegardes_attestation_id=${action?.params?.sauvegardes_attestation_id}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.ok) {
        console.log("Request successful");
        const responseData = await response.json();
        toast.success(responseData?.message);
        setSignature(true);
      } else if (response.status === 500) {
        toast.error("Une erreur s'est produite");
      } else {
        console.error("Request failed");
        setSignature(true);
        const responseData = await response.json();
        console.log(responseData.message);
        toast.error(responseData.message);
      }
    } catch (error) {
      console.error("An error occurred", error);
      // toast.error("Une erreur s'est produite");
    }
  };
  const [modal, setModal] = useState(false);
  const toggleModal = () => setModal(!modal);

  const handleTabClick = (tab) => {
    setActiveTab(tab); // Mettre à jour l'état lors du clic sur un onglet
  };
  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        <NavItem>
          <NavLink
            style={navStyle}
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            onClick={() => handleTabClick("details")}
          >
            Détails document fusion
          </NavLink>
        </NavItem>

        {sauvegardesAttestationData?.hm_accessibles?.map((key, index) =>
          key === "hm_souscriptions" ? (
            <NavItem key={index}>
              <NavLink
                style={navStyle}
                className={`nav-link ${
                  activeTab === "souscriptions" ? "active" : ""
                }`}
                onClick={() => handleTabClick("souscriptions")}
              >
                {!loading ? (
                  souscriptionsData?.title
                ) : (
                  <>
                    <h5 className="card-title placeholder-glow">
                      <span
                        style={{ height: "1em" }}
                        className="placeholder col-6"
                      ></span>
                    </h5>
                  </>
                )}
              </NavLink>
            </NavItem>
          ) : null
        )}
      </Nav>
    );
  };

  const getData = async () => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/sauvegardes_attestations/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 403) {
        navigate(`${backUrl}/forbidden`);
      }
      if (response.status === 500) {
        navigate(`${backUrl}/error`);
      }
      if (response.status === 203) {
        navigate(`${backUrl}/error404`);
      }
      if (response.status === 401) {
        localStorage.removeItem("auth_token_" + api);
        localStorage.removeItem("authUser_" + api);
        localStorage.removeItem("sideBar_" + api);
        navigate(`${backUrl}/login`);
        window.location.reload(false);
      }
      // if (!response.ok) {
      //   localStorage.removeItem("auth_token_"+api);
      //   localStorage.removeItem("authUser_"+api);
      //   localStorage.removeItem("sideBar_"+api);
      //   history('/backoffice_test/login');
      //   window.location.reload(false);
      //   throw new Error(`Request failed with status: ${response.status}`);
      // }

      const sauvegardesAttestationData = await response.json();
      setSauvegardesAttestationData(sauvegardesAttestationData);

      {
        sauvegardesAttestationData?.hm_accessibles?.map(async (key, index) =>
          key === "hm_dossier_de_souscriptions"
            ? await getDossier()
            : key === "hm_rompus"
            ? await getRompus()
            : key === "hm_souscriptions"
            ? await getSouscriptionHm()
            : null
        );
      }
    } catch (error) {
      // Handle any other errors that might occur during the fetch
      console.error("Error fetching data:", error.message);
    }
  };
  const fetchData = async () => {
    try {
      await getData();
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  return (
    <DocumentFusion
      Titre={"Retour vers la page précédente"}
      loading={loading}
      setLoading={setLoading}
      sauvegardesAttestationData={sauvegardesAttestationData}
      activeTab={activeTab}
      fetchData={fetchData}
      handleAction={handleAction}
      toggleModal={toggleModal}
      signature={signature}
      handleTabClick={handleTabClick}
      id={id}
      CustomNavTabs={CustomNavTabs}
      api={api}
      wait={wait}
    />
  );
};

export default SauvegardesAttestationDetail;
